/* Copyright (c) 2018 Scaper */

import { UserInfo } from "@firebase/auth-types";
import * as React from "react";

interface IProps {
    userInfo: UserInfo;
}

export class Profile extends React.PureComponent<IProps, {}> {
    public render() {
        const { userInfo } = this.props;
        const { displayName, email, photoURL } = userInfo;
        return (
            <div className="col s12 m8 offset-m2 l6 offset-l3">
                <div className="card-panel grey lighten-5">
                    <div className="row valign-wrapper">
                        <div className="col s2">
                            <img className="circle responsive-img" src={photoURL || undefined} alt="" />
                        </div>
                        <div className="col s10">
                            <h4 className="black-text name">{displayName}</h4>
                            <h5 className="black-text email">{email}</h5>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
